// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ApiTwoToneSvg from "@fishx/icons-svg/es/asn/ApiTwoTone";
import FishxIcon from '../components/FishxIcon';

var ApiTwoTone = function ApiTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ApiTwoToneSvg
  }));
};

ApiTwoTone.displayName = 'ApiTwoTone';
export default React.forwardRef(ApiTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ApiTwoTone.js
// module id = 2002
// module chunks = 0